import React from 'react'
import PropTypes from 'prop-types'
import MaterialAutocomplete from 'components/generic/form/AsyncAutocomplete/MaterialAutocomplete'
import Dinero from 'dinero.js'

const MaterialCodeCell = ({ cellData, isView, priceType, apiRef, createOrUpdateTotalRow, onEditCallback }) => {
  const { row } = cellData

  if (row.id === 'total') {
    return 'Total'
  }

  if (isView) {
    return `${row.materialName} (${row.code})`
  }

  return (
    <MaterialAutocomplete
      defaultValue={{
        commonName: row.materialName,
        code: row.code,
        materialTypeId: row.materialTypeId,
      }}
      InputProps={{
        disableUnderline: true,
      }}
      onChange={newValue => {
        if (!newValue) return
        // skip rest of function if material code did not change
        if (row?.code === newValue?.code) return

        onEditCallback()

        const { id, code, defaultPriceEntry } = newValue
        const price = defaultPriceEntry[priceType]?.price

        const rowPayload = {
          ...row,
          code,
          materialTypeId: id,
          um: defaultPriceEntry?.weightUnits,
          price: newValue ? Dinero({ ...price }).toUnit() : null,
        }

        apiRef.current?.updateRows([rowPayload])
        createOrUpdateTotalRow()
      }}
    />
  )
}

MaterialCodeCell.propTypes = {
  cellData: PropTypes.object.isRequired,
  isView: PropTypes.bool,
  priceType: PropTypes.string,
  apiRef: PropTypes.object.isRequired,
  createOrUpdateTotalRow: PropTypes.func,
  onEditCallback: PropTypes.func,
}

MaterialCodeCell.defaultProps = {
  isView: false,
  priceType: 'buyPrice',
  createOrUpdateTotalRow: () => {},
  onEditCallback: () => {},
}

export default MaterialCodeCell
